module.exports = __webpack_public_path__ + "e2a28653cb5235c019e4fc4d932c0ef3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/nvidia_2023_chart.png
// module id = 1708
// module chunks = 0